import styled from 'styled-components'
import { TxSuccessIcon, CloseIcon, LinkExternal, TxFailedIcon, Text } from '@pancakeswap/uikit'
import { getBlockExploreLink } from 'utils'
import { TransactionDetails } from 'state/transactions/reducer'
import CircleLoader from '../../Loader/CircleLoader'

const TransactionState = styled.div<{ pending: boolean; success?: boolean }>`
  display: flex;
  gap: 4px;
  align-items: center;
  text-decoration: none !important;
  /* height: 20px; */
  color: ${({ theme }) => theme.colors.primary};

  > a {
    path {
      fill: white;
    }
  }

  &:not(first-child) {
    margin-top: 12px;
  }
`

// const IconWrapper = styled.div<{ pending: boolean; success?: boolean }>`
//   color: ${({ pending, success, theme }) =>
//     pending ? theme.colors.primary : success ? theme.colors.success : theme.colors.failure};
// `

export default function Transaction({
  tx,
  chainId,
  isSwap,
}: {
  tx: TransactionDetails
  chainId: number
  isSwap?: boolean
}) {
  const summary = tx?.summary
  const pending = !tx?.receipt
  const success = !pending && tx && (tx.receipt?.status === 1 || typeof tx.receipt?.status === 'undefined')

  if (!chainId) return null

  const filtersummary = summary.replace('min.', 'min').replace('max.', 'max')

  return (
    <TransactionState pending={pending} success={success}>
      {pending ? (
        <CircleLoader />
      ) : success ? (
        <TxSuccessIcon width={20} height={20} />
      ) : (
        <TxFailedIcon width={20} height={20} />
      )}
      {/* <IconWrapper pending={pending} success={success}>
      </IconWrapper> */}
      <LinkExternal largeIcon isBscScan href={getBlockExploreLink(tx.hash, 'transaction', chainId)} isSwap={isSwap}>
        <Text fontWeight="500" fontSize="14px" lineHeight="140%">
          {filtersummary ?? tx.hash}
        </Text>
      </LinkExternal>
    </TransactionState>
  )
}
